{
  "HELP_CENTER": {
    "TITLE": "Yardım Merkezi",
    "NEW_PAGE": {
      "DESCRIPTION": "Müşterileriniz için kendi kendine hizmet verebilecekleri yardım merkezi portalları oluşturun. Beklemeden hızlıca yanıt bulmalarına yardımcı olun. Talepleri kolaylaştırın, temsilci verimliliğini artırın ve müşteri desteğini bir üst seviyeye taşıyın.",
      "CREATE_PORTAL_BUTTON": "Portal Oluştur"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Başlıksız"
    },
    "HEADER": {
      "FILTER": "Filtrele",
      "SORT": "Sırala",
      "LOCALE": "Yerel",
      "SETTINGS_BUTTON": "Ayarlar",
      "NEW_BUTTON": "Yeni Makale",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Yayınlandı",
        "DRAFT": "Draft",
        "ARCHIVED": "Arşivlendi"
      },
      "TITLES": {
        "ALL_ARTICLES": "Tüm Makaleler",
        "MINE": "Benim Makalelerim",
        "DRAFT": "Draft Makaleler",
        "ARCHIVED": "Arşivlenmiş Makaleler"
      },
      "LOCALE_SELECT": {
        "TITLE": "Dil seçin",
        "PLACEHOLDER": "Dil seçin",
        "NO_RESULT": "Dil bulunamadı",
        "SEARCH_PLACEHOLDER": "Dil ara"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Tüm Makaleler",
      "PUBLISH_BUTTON": "Yayınla",
      "MOVE_TO_ARCHIVE_BUTTON": "Arşive Taşı",
      "PREVIEW": "Önizleme",
      "ADD_TRANSLATION": "Çeviri Ekle",
      "OPEN_SIDEBAR": "Kenar Çubuğunu Aç",
      "CLOSE_SIDEBAR": "Kenar Çubuğunu Kapat",
      "SAVING": "Kaydediliyor...",
      "SAVED": "Kaydedildi"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Resim yükle",
        "UPLOADING": "Yükleniyor...",
        "SUCCESS": "Resim başarıyla yüklendi",
        "ERROR": "Resim yüklenirken hata oluştu",
        "UN_AUTHORIZED_ERROR": "Resim yükleme yetkiniz yok",
        "ERROR_FILE_SIZE": "Resim boyutu {size}MB'dan küçük olmalıdır",
        "ERROR_FILE_FORMAT": "Resim formatı jpg, jpeg veya png olmalıdır",
        "ERROR_FILE_DIMENSIONS": "Resim boyutları 2000 x 2000'den küçük olmalıdır"
      },
      "ANCHOR": {
        "BUTTON": "Çapa ekle",
        "TITLE": "Çapa ekle",
        "SUBMIT": "Ekle",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Makale Ayarları",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategori",
          "TITLE": "Kategori Seç",
          "PLACEHOLDER": "Kategori Seç",
          "NO_RESULT": "Hiçbir kategori bulunamadı",
          "SEARCH_PLACEHOLDER": "Kategori Ara"
        },
        "AUTHOR": {
          "LABEL": "Yazar",
          "TITLE": "Yazar Seç",
          "PLACEHOLDER": "Yazar Seç",
          "NO_RESULT": "Hiçbir yazar bulunamadı",
          "SEARCH_PLACEHOLDER": "Yazar Ara"
        },
        "META_TITLE": {
          "LABEL": "Meta Başlık",
          "PLACEHOLDER": "Bir meta başlık ekleyin"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta Açıklama",
          "PLACEHOLDER": "Daha iyi SEO sonuçları için meta açıklamanızı ekleyin..."
        },
        "META_TAGS": {
          "LABEL": "Meta Etiketleri",
          "PLACEHOLDER": "Virgülle ayrılmış meta etiketleri ekleyin..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Makaleyi Arşivle",
        "DELETE": "Makaleyi Sil"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Kategorize Edilmemiş",
      "SEARCH_RESULTS": "{query} için arama sonuçları",
      "EMPTY_TEXT": "Cevaplarına eklemek için makale arayın.",
      "SEARCH_LOADER": "Aranıyor...",
      "INSERT_ARTICLE": "Ekle",
      "NO_RESULT": "Hiçbir makale bulunamadı",
      "COPY_LINK": "Makale bağlantısını panoya kopyala",
      "OPEN_LINK": "Makaleyi yeni sekmede aç",
      "PREVIEW_LINK": "Makaleyi Önizle"
    },
    "PORTAL": {
      "HEADER": "Portallar",
      "DEFAULT": "Varsayılan",
      "NEW_BUTTON": "Yeni Portal",
      "ACTIVE_BADGE": "aktif",
      "CHOOSE_LOCALE_LABEL": "Bir yerel seçin",
      "LOADING_MESSAGE": "Portallar yükleniyor...",
      "ARTICLES_LABEL": "makaleler",
      "NO_PORTALS_MESSAGE": "Kullanılabilir portal yok",
      "ADD_NEW_LOCALE": "Yeni bir yerel ekleyin",
      "POPOVER": {
        "TITLE": "Portallar",
        "PORTAL_SETTINGS": "Portal Ayarları",
        "SUBTITLE": "Birden çok portalınız var ve her bir portal için farklı yerelleriniz olabilir.",
        "CANCEL_BUTTON_LABEL": "İptal Et",
        "CHOOSE_LOCALE_BUTTON": "Yerel Seç"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "makaleler",
            "ADD": "Yerel ekle",
            "VISIT": "Siteyi ziyaret et",
            "SETTINGS": "Ayarlar",
            "DELETE": "Sil"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Portal Konfigürasyonları",
            "ITEMS": {
              "NAME": "İsim",
              "DOMAIN": "Özel domain",
              "SLUG": "Slug",
              "TITLE": "Portal başlığı",
              "THEME": "Tema rengi",
              "SUB_TEXT": "Portal alt metni"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Kullanılabilir yereller",
            "TABLE": {
              "NAME": "Yerel adı",
              "CODE": "Yerel kod",
              "ARTICLE_COUNT": "Makale sayısı",
              "CATEGORIES": "Kategori sayısı",
              "SWAP": "Değiştir",
              "DELETE": "Sil",
              "DEFAULT_LOCALE": "Varsayılan"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Portalı Sil",
          "MESSAGE": "Bu portalı silmek istediğinizden emin misiniz",
          "YES": "Evet, portalı sil",
          "NO": "Hayır, portal kalsın",
          "API": {
            "DELETE_SUCCESS": "Portal başarıyla silindi",
            "DELETE_ERROR": "Portal silinirken hata oluştu"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Portalı Düzenle",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Temel Bilgiler"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Portal özelleştirme"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategoriler"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Yereller"
          }
        },
        "CATEGORIES": {
          "TITLE": "Şu yereldeki Kategoriler",
          "NEW_CATEGORY": "Yeni kategori",
          "TABLE": {
            "NAME": "İsim",
            "DESCRIPTION": "Açıklama",
            "LOCALE": "Yerel",
            "ARTICLE_COUNT": "Makale sayısı",
            "ACTION_BUTTON": {
              "EDIT": "Kategori düzenle",
              "DELETE": "Kategori sil"
            },
            "EMPTY_TEXT": "Hiç kategori bulunamadı"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Temel ayarları güncelle"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Yardım Merkezi Bilgileri",
            "BODY": "Portalin temel bilgileri"
          },
          "CUSTOMIZATION": {
            "TITLE": "Yardım Merkezi Özelleştirme",
            "BODY": "Portali özelleştir"
          },
          "FINISH": {
            "TITLE": "Voila! 🎉",
            "BODY": "Her şey hazır!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Geri",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Portal Oluştur",
            "TITLE": "Yardım Merkezi Bilgileri",
            "CREATE_BASIC_SETTING_BUTTON": "Portal temel ayarlarını oluştur"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Portal özelleştirme",
            "TITLE": "Yardım Merkezi Özelleştirme",
            "UPDATE_PORTAL_BUTTON": "Portal ayarlarını güncelle"
          },
          "FINISH_PAGE": {
            "TITLE": "Voila!🎉 Her şey ayarlandı!",
            "MESSAGE": "Bu oluşturulan portalı şimdi tüm portal sayfanızda görebilirsiniz.",
            "FINISH": "Tüm portallar sayfasına git"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Logo yükle",
          "HELP_TEXT": "Bu logo portal başlığında görüntülenecektir.",
          "IMAGE_UPLOAD_SUCCESS": "Logo başarıyla yüklendi",
          "IMAGE_UPLOAD_ERROR": "Logo başarıyla silindi",
          "IMAGE_DELETE_ERROR": "Logo silinirken hata oluştu"
        },
        "NAME": {
          "LABEL": "İsim",
          "PLACEHOLDER": "Portal adı",
          "HELP_TEXT": "İsim, herkese açık portalda dahili olarak kullanılacaktır.",
          "ERROR": "İsim gereklidir"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "URL'ler için portal slug",
          "ERROR": "Slug gereklidir"
        },
        "DOMAIN": {
          "LABEL": "Özel Domain",
          "PLACEHOLDER": "Portal özel domain",
          "HELP_TEXT": "Yalnızca portalınız için özel bir domain kullanmak istiyorsanız ekleyin. Örn: {exampleURL}",
          "ERROR": "Geçerli bir domain URL girin"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Ana Sayfa Bağlantısı",
          "PLACEHOLDER": "Portal ana sayfa bağlantısı",
          "HELP_TEXT": "Portaldan ana sayfaya dönmek için kullanılan bağlantı. Örn: {exampleURL}",
          "ERROR": "Geçerli bir ana sayfa URL girin"
        },
        "THEME_COLOR": {
          "LABEL": "Portal tema rengi",
          "HELP_TEXT": "Bu renk portal için tema rengi olarak gösterilecektir."
        },
        "PAGE_TITLE": {
          "LABEL": "Sayfa Başlığı",
          "PLACEHOLDER": "Portal sayfa başlığı",
          "HELP_TEXT": "Sayfa başlığı herkese açık portalda kullanılacaktır.",
          "ERROR": "Sayfa başlığı gereklidir"
        },
        "HEADER_TEXT": {
          "LABEL": "Başlık Metni",
          "PLACEHOLDER": "Portal başlık metni",
          "HELP_TEXT": "Portal başlık metni herkese açık portalda kullanılacaktır.",
          "ERROR": "Portal başlık metni gereklidir"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal başarıyla oluşturuldu.",
          "ERROR_MESSAGE_FOR_BASIC": "Portal oluşturulamadı. Lütfen tekrar deneyin.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal başarıyla güncellendi.",
          "ERROR_MESSAGE_FOR_UPDATE": "Portal güncellenemedi. Lütfen tekrar deneyin."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Yeni bir yerel dil ekle",
        "SUB_TITLE": "Bu, kullanılabilir çeviri listesine yeni bir yerel dil ekler.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Yerel Dil",
          "PLACEHOLDER": "Bir dil seçin",
          "ERROR": "Yerel dil gereklidir"
        },
        "BUTTONS": {
          "CREATE": "Yerel dil oluştur",
          "CANCEL": "İptal Et"
        },
        "API": {
          "SUCCESS_MESSAGE": "Yerel dil başarıyla eklendi",
          "ERROR_MESSAGE": "Yerel dil eklenemedi. Lütfen tekrar deneyin."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Varsayılan yerel dil başarıyla güncellendi",
          "ERROR_MESSAGE": "Varsayılan yerel dil güncellenemedi. Lütfen tekrar deneyin."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Yerel dil başarıyla portaldan kaldırıldı",
          "ERROR_MESSAGE": "Yerel dil portaldan kaldırılamadı. Lütfen tekrar deneyin."
        }
      }
    },
    "TABLE": {
      "404": "Arama kriterlerinize uygun makale bulunamadı 🔍",
      "LOADING_MESSAGE": "Makaleler yükleniyor...",
      "NO_ARTICLES": "Uygun makale bulunmamaktadır",
      "HEADERS": {
        "TITLE": "Başlık",
        "CATEGORY": "Kategori",
        "READ_COUNT": "Görüntülenme",
        "STATUS": "Durum",
        "LAST_EDITED": "Son düzenleme"
      },
      "COLUMNS": {
        "BY": "tarafından",
        "AUTHOR_NOT_AVAILABLE": "Yazar uygun değil"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Makale yükleniyor...",
      "TITLE_PLACEHOLDER": "Makale başlığı buraya yazılır",
      "CONTENT_PLACEHOLDER": "Makalenizi buraya yazın",
      "API": {
        "ERROR": "Makale kaydedilirken hata oluştu"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Makale yayımlanırken hata oluştu",
        "SUCCESS": "Makale başarıyla yayımlandı"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Makale arşivlenirken hata oluştu",
        "SUCCESS": "Makale başarıyla arşivlendi"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Makale Draft'a alınırken hata oluştu",
        "SUCCESS": "Makale başarıyla Draft'a alındı"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Silmeyi onayla",
          "MESSAGE": "Makaleyi silmek istediğinizden emin misiniz?",
          "YES": "Evet, Sil",
          "NO": "Hayır, kalsın"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Makale başarıyla silindi",
        "ERROR_MESSAGE": "Makale silinirken hata oluştu"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Lütfen makale başlığını ve içeriğini ekleyin, ardından ayarları güncelleyebilirsiniz"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Makaleleri arayın"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Kategori oluştur",
        "SUB_TITLE": "Kategori, makaleleri kategorize etmek için genel portalda kullanılacaktır.",
        "PORTAL": "Portal",
        "LOCALE": "Yerel",
        "NAME": {
          "LABEL": "İsim",
          "PLACEHOLDER": "Kategori adı",
          "HELP_TEXT": "Kategori adı ve simgesi, makaleleri kategorize etmek için genel portalda kullanılacaktır.",
          "ERROR": "İsim gereklidir"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "URL'ler için kategori slug'ı",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug gereklidir"
        },
        "DESCRIPTION": {
          "LABEL": "Açıklama",
          "PLACEHOLDER": "Kategori hakkında kısa bir açıklama yapın.",
          "ERROR": "Açıklama zorunludur"
        },
        "BUTTONS": {
          "CREATE": "Kategori oluştur",
          "CANCEL": "İptal Et"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategori başarıyla oluşturuldu",
          "ERROR_MESSAGE": "Kategori oluşturulamıyor"
        }
      },
      "EDIT": {
        "TITLE": "Kategori düzenle",
        "SUB_TITLE": "Bir kategoriyi düzenlemek, kategoriyi genel portalda güncelleyecektir.",
        "PORTAL": "Portal",
        "LOCALE": "Yerel",
        "NAME": {
          "LABEL": "İsim",
          "PLACEHOLDER": "Kategori adı",
          "HELP_TEXT": "Kategori adı ve simgesi, makaleleri kategorize etmek için genel portalda kullanılacaktır.",
          "ERROR": "İsim gereklidir"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "URL'ler için kategori slug'ı",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug gereklidir"
        },
        "DESCRIPTION": {
          "LABEL": "Açıklama",
          "PLACEHOLDER": "Kategori hakkında kısa bir açıklama yapın.",
          "ERROR": "Açıklama zorunludur"
        },
        "BUTTONS": {
          "CREATE": "Kategoriyi güncelle",
          "CANCEL": "İptal Et"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategori başarıyla güncellendi",
          "ERROR_MESSAGE": "Kategori güncellenemiyor"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategori başarıyla silindi",
          "ERROR_MESSAGE": "Kategori silinemiyor"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Makaleleri Ara",
      "PLACEHOLDER": "Makaleleri arayın",
      "NO_RESULT": "Hiçbir sonuç bulunamadı",
      "SEARCHING": "Aranıyor...",
      "SEARCH_BUTTON": "Ara",
      "INSERT_ARTICLE": "Bağlantı ekle",
      "IFRAME_ERROR": "URL boş veya geçersiz. İçerik görüntülenemiyor.",
      "OPEN_ARTICLE_SEARCH": "Yardım Merkezi'nden makale ekle",
      "SUCCESS_ARTICLE_INSERTED": "Makale başarıyla eklendi",
      "PREVIEW_LINK": "Bağlantıyı Önizle",
      "CANCEL": "Kapat",
      "BACK": "Geri",
      "BACK_RESULTS": "Sonuçlara Geri Dön"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Yardım Merkezi",
      "DESCRIPTION": "Kullanıcı dostu self-servis portalları oluşturun. Kullanıcılarınıza 7/24 erişim sağlayın. Bu özelliği etkinleştirmek için aboneliğinizi yükseltin.",
      "SELF_HOSTED_DESCRIPTION": "Kullanıcı dostu self-servis portalları oluşturun. Kullanıcılarınıza 7/24 erişim sağlayın. Lütfen bu özelliği etkinleştirmek için yöneticinizle iletişime geçin.",
      "BUTTON": {
        "LEARN_MORE": "Daha Fazla",
        "UPGRADE": "Yükselt"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Çoklu portallar",
          "DESCRIPTION": "Aynı hesabı kullanarak farklı ürünler için birden çok yardım merkezi portalı oluşturun."
        },
        "LOCALES": {
          "TITLE": "Yerel destek",
          "DESCRIPTION": "Portalı kendi dilinizde yerelleştirin. Tüm yerel ayarları destekliyoruz ve her makale için çeviri yapmanıza izin veriyoruz."
        },
        "SEO": {
          "TITLE": "SEO dostu tasarım",
          "DESCRIPTION": "Meta etiketlerinizi özelleştirerek SEO dostu sayfalarla arama motorlarındaki görünürlüğünüzü artırın."
        },
        "API": {
          "TITLE": "Tam API desteği",
          "DESCRIPTION": "API'larımızı kullanarak portali başsız bir CMS olarak üçüncü taraf ön yüz çerçeveleriyle kullanın."
        }
      }
    },
    "LOADING": "Yükleniyor...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} görüntülenme | {count} görüntülenme",
          "DROPDOWN_MENU": {
            "PUBLISH": "Yayınla",
            "DRAFT": "Draft",
            "ARCHIVE": "Arşivle",
            "DELETE": "Sil"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Yayınlandı",
            "ARCHIVED": "Arşivlendi"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Kategorisiz"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Tüm makaleler",
          "MINE": "Benim",
          "DRAFT": "Draft",
          "PUBLISHED": "Yayınlandı",
          "ARCHIVED": "Arşivlendi"
        },
        "CATEGORY": {
          "ALL": "Tüm kategoriler"
        },
        "LOCALE": {
          "ALL": "Tüm diller"
        },
        "NEW_ARTICLE": "Yeni makale"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Bir makale yazın",
          "SUBTITLE": "Zengin bir makale yazın, hadi başlayalım!",
          "BUTTON_LABEL": "Yeni makale"
        },
        "MINE": {
          "TITLE": "Burada henüz herhangi bir makale yazmadınız",
          "SUBTITLE": "Sizin tarafınızdan yazılan tüm makaleler hızlı erişim için burada görünür."
        },
        "DRAFT": {
          "TITLE": "Draft'ta hiç makale yok",
          "SUBTITLE": "Draft makaleler burada görünecektir"
        },
        "PUBLISHED": {
          "TITLE": "Yayınlanmış makale yok",
          "SUBTITLE": "Yayınlanan makaleler burada görünecektir"
        },
        "ARCHIVED": {
          "TITLE": "Arşivde hiç makale yok",
          "SUBTITLE": "Arşivlenen makaleler portalda görünmez; kullanımdan kaldırılmış veya güncelliğini yitirmiş sayfaları işaretlemek için kullanabilirsiniz"
        },
        "CATEGORY": {
          "TITLE": "Bu kategoride hiç makale yok",
          "SUBTITLE": "Bu kategorideki makaleler burada görünecektir"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Yeni kategori",
        "EDIT_CATEGORY": "Kategori düzenle",
        "CATEGORIES_COUNT": "{n} kategori | {n} kategori",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategoriler ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} makale) | {categoryName} ({categoryCount} makale)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Hiç kategori bulunamadı",
        "SUBTITLE": "Kategoriler burada görünecektir. 'Yeni Kategori' düğmesine tıklayarak bir kategori ekleyebilirsiniz."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} makale | {count} makale",
        "EXPAND": "Alt kategorileri göster",
        "COLLAPSE": "Alt kategorileri gizle",
        "MENU": {
          "NEW_ARTICLE": "Yeni makale",
          "ADD_SUBCATEGORY": "Alt kategori ekle",
          "EDIT": "Düzenle",
          "DELETE": "Sil"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategori başarıyla oluşturuldu",
            "ERROR_MESSAGE": "Kategori oluşturulamıyor"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategori başarıyla güncellendi",
            "ERROR_MESSAGE": "Kategori güncellenemiyor"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategori başarıyla silindi",
            "ERROR_MESSAGE": "Kategori silinemiyor"
          },
          "CONFIRM": {
            "TITLE": "Kategoriyi sil",
            "DESCRIPTION": "Bu kategoriyi silmek istediğinizden emin misiniz? Makaleleri kategorisiz hale gelecektir.",
            "DESCRIPTION_WITH_CHILDREN": "Bu kategoriyi silmek istediğinizden emin misiniz? Makaleleri kategorisiz hale gelecek ve {count} alt kategorisi üst düzeye taşınacaktır. | Bu kategoriyi silmek istediğinizden emin misiniz? Makaleleri kategorisiz hale gelecek ve {count} alt kategorisi üst düzeye taşınacaktır.",
            "CONFIRM": "Sil"
          }
        },
        "HEADER": {
          "CREATE": "Kategori oluştur",
          "EDIT": "Kategori düzenle",
          "DESCRIPTION": "Bir kategoriyi düzenlemek, kategoriyi genel portalda güncelleyecektir.",
          "PORTAL": "Portal",
          "LOCALE": "Yerel"
        },
        "FORM": {
          "NAME": {
            "LABEL": "İsim",
            "PLACEHOLDER": "Kategori adı",
            "ERROR": "Ad gerekli"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "URL'ler için kategori slug'ı",
            "ERROR": "Slug gereklidir",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Açıklama",
            "PLACEHOLDER": "Kategori hakkında kısa bir açıklama yapın.",
            "ERROR": "Açıklama gerekli"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Üst kategori",
            "PLACEHOLDER": "Bir üst kategori seçin",
            "NONE": "Yok (üst düzey)"
          }
        },
        "BUTTONS": {
          "CREATE": "Oluştur",
          "EDIT": "Güncelle",
          "CANCEL": "İptal Et"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Kullanılabilir dil yok | {n} dil | {n} dil",
      "NEW_LOCALE_BUTTON_TEXT": "Yeni dil",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} makale | {count} makale",
        "CATEGORIES_COUNT": "{count} kategori | {count} kategori",
        "DEFAULT": "Varsayılan",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Varsayılan yap",
          "DELETE": "Sil"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Yeni bir yerel ekleyin",
        "DESCRIPTION": "Bu makalenin yazılacağı dili seçin. Bu, çeviri listenize eklenecek ve daha sonra başka dil ekleyebilirsiniz.",
        "COMBOBOX": {
          "PLACEHOLDER": "Dil seçin..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Yerel dil başarıyla eklendi",
          "ERROR_MESSAGE": "Yerel dil eklenemedi. Lütfen tekrar deneyin."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Kaydediliyor...",
          "SAVED": "Kaydedildi"
        },
        "PREVIEW": "Önizleme",
        "PUBLISH": "Yayınla",
        "DRAFT": "Draft",
        "ARCHIVE": "Arşivle",
        "BACK_TO_ARTICLES": "Makalelere geri dön"
      },
      "DRAFT": {
        "PENDING_LABEL": "Yayınlanmamış değişiklikler",
        "PROMOTE": "Değişiklikleri yayınla",
        "DISCARD": "Değişiklikleri sil",
        "PROMOTE_SUCCESS": "Draft değişiklikler canlı makaleye yayınlandı",
        "PROMOTE_ERROR": "Draft değişiklikler yayınlanamadı",
        "DISCARD_SUCCESS": "Draft değişiklikler silindi",
        "DISCARD_ERROR": "Draft değişiklikler silinemedi"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Sürüm geçmişi",
        "TITLE": "Sürüm geçmişi",
        "BACK": "Makaleye geri dön",
        "LOADING": "Sürümler yükleniyor...",
        "EMPTY": "Henüz sürüm yok. Bu makalede yapılan değişiklikler burada görünecek.",
        "EMPTY_CONTENT": "Bu sürümde içerik yok.",
        "CURRENT_BADGE": "Güncel",
        "RESTORED_BADGE": "Geri yüklendi",
        "AUTOMATED_USER": "Otomatik güncelleme",
        "RESTORE": "Bu sürümü geri yükle",
        "RESTORE_DIALOG": {
          "TITLE": "Bu sürüm geri yüklensin mi?",
          "DESCRIPTION": "Makale bu sürümün metnine geri döner. Hiçbir şey kaybolmaz — güncel metin geçmişte saklanır ve yayınlanmış bir makalede, siz değişikliği yayınlayana kadar canlı sürüm gösterilmeye devam eder.",
          "CONFIRM": "Geri yükle"
        },
        "RESTORE_SUCCESS": "Sürüm geri yüklendi",
        "RESTORE_ERROR": "Bu sürüm geri yüklenemedi",
        "FETCH_ERROR": "Sürüm geçmişi yüklenemedi"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Daha fazla özellik",
        "TRANSLATE": "Çevir",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Kategorize Edilmemiş",
        "EDITOR_PLACEHOLDER": "Bir şeyler yazın...",
        "HTML_EMBED": {
          "TITLE": "Özel HTML ekle",
          "DESCRIPTION": "iframe, embed veya widget parçacığı gibi ham HTML yapıştırın. Yayınlanan makalede olduğu gibi görüntülenecektir.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Ekle"
        },
        "PRIMARY_CATEGORY": "Ana kategori"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Makale özellikleri",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Meta Açıklama",
        "META_DESCRIPTION_PLACEHOLDER": "Meta açıklama ekle",
        "META_TITLE": "Meta Başlık",
        "META_TITLE_PLACEHOLDER": "Meta başlık ekle",
        "META_TAGS": "Meta Etiketleri",
        "META_TAGS_PLACEHOLDER": "Meta etiket ekle",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Dil sürümleri",
        "LANGUAGE_MUTATIONS_EMPTY": "Henüz bağlı makale yok",
        "ADD_MUTATION": "Ekle",
        "REMOVE_MUTATION": "Kaldır"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Dil sürümlerini bağla",
        "SEARCH_PLACEHOLDER": "Makaleleri başlığa göre ara",
        "EMPTY": "Eşleşen makale yok",
        "CANCEL": "İptal",
        "ADD_SELECTED": "Seçilenleri ekle",
        "SUCCESS": "Sürümler güncellendi",
        "ERROR": "Sürümler güncellenemedi"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Makaleyi çevir",
        "DESCRIPTION": "Bu makaleyi çevirmek istediğiniz dilleri seçin. Zaten çevrilmiş diller, inceleme için taslak olarak yeniden çevrilecektir.",
        "EMPTY": "Başka dil mevcut değil.",
        "CONNECTED_BADGE": "Çevrildi",
        "CANCEL": "İptal",
        "TRANSLATE": "Çevir",
        "SUCCESS": "Çeviri kısa süre içinde başlayacak. Çevrilen makaleler yakında dil sürümleri olarak görünecek.",
        "ERROR": "Çeviri başlatılamadı"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Makale kaydedilirken hata oluştu"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Yeni portal",
      "PORTALS": "Portallar",
      "CREATE_PORTAL": "Birden çok portal oluşturun ve yönetin",
      "ARTICLES": "makaleler",
      "DOMAIN": "alan adı",
      "PORTAL_NAME": "Portal adı"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Yeni portal oluştur",
      "DESCRIPTION": "Portalınıza bir isim verin ve kullanıcı dostu bir URL slug'ı oluşturun. Her ikisini de daha sonra ayarlardan değiştirebilirsiniz.",
      "CONFIRM_BUTTON_LABEL": "Oluştur",
      "NAME": {
        "LABEL": "İsim",
        "PLACEHOLDER": "Kullanım Kılavuzu",
        "MESSAGE": "Portalınız için bir isim seçin.",
        "ERROR": "Ad gerekli"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug gereklidir",
        "FORMAT_ERROR": "Yalnızca harf, rakam ve kısa çizgi kullanın, örneğin: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Resim yüklenemedi! Tekrar deneyin",
          "IMAGE_UPLOAD_SUCCESS": "Resim başarıyla eklendi. Logoyu kaydetmek için lütfen değişiklikleri kaydet'e tıklayın",
          "IMAGE_DELETE_SUCCESS": "Logo başarıyla silindi",
          "IMAGE_DELETE_ERROR": "Logo silinemedi",
          "IMAGE_UPLOAD_SIZE_ERROR": "Resim boyutu {size}MB'dan küçük olmalıdır"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "İsim",
          "PLACEHOLDER": "Portal adı",
          "ERROR": "Ad gerekli"
        },
        "HEADER_TEXT": {
          "LABEL": "Başlık metni",
          "PLACEHOLDER": "Portal başlık metni"
        },
        "PAGE_TITLE": {
          "LABEL": "Sayfa başlığı",
          "PLACEHOLDER": "Portal sayfa başlığı"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Ana sayfa bağlantısı",
          "PLACEHOLDER": "Portal ana sayfa bağlantısı",
          "ERROR": "Geçersiz URL. Ana sayfa bağlantısı 'http://' veya 'https://' ile başlamalıdır."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Canlı sohbet widget’ı",
          "PLACEHOLDER": "Canlı sohbet widget’ı seçin",
          "HELP_TEXT": "Yardım merkezinizde görünecek canlı sohbet widget’ını seçin"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Herkese açık",
          "HELP_TEXT": "Portalı bağlantıya sahip herkes için erişilebilir yapın.",
          "OPTIONS": {
            "PUBLIC": "Evet",
            "PRIVATE": "Hayır"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Bağlantı hedefi",
          "HELP_TEXT": "Makalelerdeki bağlantıların geçerli pencerede mi yoksa yeni pencerede mi açılacağını seçin.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Geçerli pencere",
            "NEW_WINDOW": "Yeni pencere"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Varsayılan resim boyutu",
          "HELP_TEXT": "Bir makaleye eklediğiniz her resme uygulanan boyut. Resimleri kendi boyutunda eklemek için 'Original' seçeneğini seçin, ya da her resim için ayrı ayrı boyut seçin."
        },
        "BRAND_COLOR": {
          "LABEL": "Marka rengi"
        },
        "CUSTOM_HTML": {
          "LABEL": "Özel HTML",
          "PLACEHOLDER": "<!-- Analytics veya izleme parçacığınızı buraya yapıştırın -->",
          "HELP_TEXT": "Her yardım merkezi sayfasında <body> etiketinin başına eklenir. Google Analytics, Google Tag Manager veya başka bir izleme parçacığı için kullanın. Kod, girildiği haliyle birebir görüntülenir ve doğrulanmaz."
        },
        "SAVE_CHANGES": "Değişiklikleri kaydet"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Özel domain",
          "LABEL": "Özel domain:",
          "DESCRIPTION": "Portalınızı özel bir domainde barındırabilirsiniz. Örneğin, web siteniz yourdomain.com ise ve portalınızın docs.yourdomain.com adresinde kullanılabilir olmasını istiyorsanız, bu alana bunu girmeniz yeterlidir.",
          "PLACEHOLDER": "Portal özel domain",
          "EDIT_BUTTON": "Özel domaini düzenle",
          "ADD_BUTTON": "Özel domain ekle",
          "DIALOG": {
            "ADD_HEADER": "Özel domain ekle",
            "EDIT_HEADER": "Özel domaini düzenle",
            "ADD_CONFIRM_BUTTON_LABEL": "Domain ekle",
            "EDIT_CONFIRM_BUTTON_LABEL": "Domaini güncelle",
            "LABEL": "Özel domain",
            "PLACEHOLDER": "Portal özel domain",
            "ERROR": "Özel domain gereklidir"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS yapılandırması",
            "DESCRIPTION": "DNS sağlayıcınızdaki hesabınıza giriş yapın ve alt alan adınız için aşağıdaki CNAME kaydını ekleyin.",
            "HELP_TEXT": "Bu işlem tamamlandıktan sonra, otomatik oluşturulan SSL sertifikasını talep etmek için destek ekibimizle iletişime geçebilirsiniz.",
            "CONFIRM_BUTTON_LABEL": "Anladım!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "{portalName} portalını sil",
          "HEADER": "Portalı Sil",
          "DESCRIPTION": "Bu portalı kalıcı olarak sil. Bu işlem geri alınamaz",
          "DIALOG": {
            "HEADER": "{portalName} portalını silmek istediğinizden emin misiniz?",
            "DESCRIPTION": "Bu, geri alınamayan kalıcı bir işlemdir.",
            "CONFIRM_BUTTON_LABEL": "Sil"
          }
        },
        "EDIT_CONFIGURATION": "Yapılandırmayı düzenle"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal başarıyla oluşturuldu",
          "ERROR_MESSAGE": "Portal oluşturulamıyor"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal başarıyla güncellendi",
          "ERROR_MESSAGE": "Portal güncellenemiyor"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Ekler",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Dosya ekle",
      "DROP_HERE": "Dosyaları buraya sürükleyip bırakın",
      "COPY_LINK": "Bağlantıyı kopyala",
      "LINK_COPIED": "Bağlantı panoya kopyalandı",
      "COPY_FAILED": "Bağlantı kopyalanamadı",
      "DELETE": "Sil",
      "CANCEL": "İptal",
      "QUEUED": "Sırada",
      "UPLOADING": "Yükleniyor",
      "UPLOAD_FAILED": "Dosya yüklenemedi",
      "FILE_TOO_LARGE": "Dosya 40 MB boyut sınırını aşıyor"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Çeviri Sözlüğü",
        "DESCRIPTION": "Burada tanımlanan terimler, her zaman aynı şekilde çevrilmeleri için AI çeviri istemine eklenir. Anahtar terim {locale} dilinde yazılır."
      },
      "NEW_TERM": "Yeni terim",
      "EMPTY_STATE": {
        "TITLE": "Henüz sözlük terimi yok",
        "SUBTITLE": "Her dil için bir terim ve çevirisini ekleyin. Bir makale çevrildiğinde, ürün diliniz tutarlı kalsın diye bu terimler zorunlu kılınır."
      },
      "LIST": {
        "TERM": "Terim",
        "TRANSLATIONS": "Çeviriler",
        "ACTIONS": "İşlemler"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Terim ekle",
          "EDIT": "Terimi düzenle",
          "DESCRIPTION": "Aşağıdaki terim, yardım merkezi makalelerinizin AI ile çevrilmesi sırasında zorunlu kılınır.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Birincil dil"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Terim ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Terim zorunludur"
          },
          "DESCRIPTION": {
            "LABEL": "Bağlam / notlar (isteğe bağlı)",
            "PLACEHOLDER": "Çevirmenin anlam karışıklığını gidermesine yardımcı olmak için bu terimin ne zaman ve nasıl kullanıldığını belirtin."
          },
          "TRANSLATIONS": "Çeviriler",
          "TRANSLATION_PLACEHOLDER": "AI'ın serbestçe çeviri yapmasına izin vermek için boş bırakın",
          "AUTO_TRANSLATE": {
            "BUTTON": "Tümünü otomatik çevir",
            "CONFIRM": "{count} dile AI ile çevrilsin mi?",
            "CONFIRM_BUTTON": "Çevir",
            "CANCEL": "İptal Et",
            "SUCCESS": "Çeviriler oluşturuldu — inceleyin ve kaydedin",
            "ERROR": "Otomatik çeviri yapılamadı, lütfen tekrar deneyin"
          }
        },
        "BUTTONS": {
          "CREATE": "Terim ekle",
          "EDIT": "Kaydet",
          "CANCEL": "İptal Et"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Terim başarıyla eklendi",
            "ERROR_MESSAGE": "Terim eklenemedi, lütfen tekrar deneyin"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Terim başarıyla güncellendi",
            "ERROR_MESSAGE": "Terim güncellenemedi, lütfen tekrar deneyin"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Terimi sil",
          "DESCRIPTION": "Bu terimi silmek istediğinizden emin misiniz? Artık çeviri sırasında zorunlu kılınmayacaktır.",
          "CONFIRM": "Sil"
        },
        "API": {
          "SUCCESS_MESSAGE": "Terim başarıyla silindi",
          "ERROR_MESSAGE": "Terim silinemedi, lütfen tekrar deneyin"
        }
      }
    }
  }
}
